// src/portals/fan/pages/DiscoverPage/components/creatorPreview/ExperienceCard.js
import React, { useState } from "react";
import { useAuth } from "../../../../../../context/AuthContext"; // ✨ 1. Import useAuth
import { mockCreator } from "../../../../../../data/mockData"; // ✨ 2. Import mockCreator
import Card from "../../../../../../components/ui/Card";
import Button from "../../../../../../components/ui/Button";
import CheckoutModal from "../../../../../../components/shared/CheckoutModal";

const ExperienceCard = ({ experience }) => {
  const [isCheckoutOpen, setCheckoutOpen] = useState(false);
  const { addConversation } = useAuth(); // ✨ 3. Get the new function from context

  const itemForCheckout = {
    ...experience,
    name: experience.title,
    type: "Experience",
  };

  // ✨ 4. This function will be called on a successful purchase
  const handleRequestSuccess = () => {
    // We pass the creator and the experience title to create the new chat
    addConversation(mockCreator, experience.title);
  };

  return (
    <>
      <Card>
        <h3 className="font-bold text-lg text-text-primary">
          {experience.title}
        </h3>
        <p className="text-primary font-semibold mt-1">
          {experience.priceETB.toLocaleString()} ETB
        </p>
        <Button onClick={() => setCheckoutOpen(true)} className="w-full mt-4">
          Request Experience
        </Button>
      </Card>
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setCheckoutOpen(false)}
        item={itemForCheckout}
        onSuccess={handleRequestSuccess} // ✨ 5. Pass the handler to the modal
      />
    </>
  );
};

export default ExperienceCard;
